<div class="mobile-footer" [class.keyboard-open]="keyboardOpen">
    <a class="mobile-footer-link" routerLink="/home" routerLinkActive="active">
        <i class="ti ti-home"></i>
    </a>
    <a class="mobile-footer-link" routerLink="/discover" routerLinkActive="active">
        <i class="ti ti-player-play"></i>
    </a>
    <div class="mobile-footer-link" routerLink="/create-offer" routerLinkActive="active">
        <div class="publish-icon">
            <i class="ti ti-plus"></i>
        </div>
    </div>
    <div class="mobile-footer-link" routerLink="/cart" routerLinkActive="active">
        <i class="ti ti-shopping-cart"></i>
        <span class="sc-pill" *ngIf="shoppingCartLineCount > 0">{{ shoppingCartLineCount }}</span>
    </div>
    <div class="mobile-footer-link" routerLink="/profile" routerLinkActive="active">
        <i class="ti ti-user" *ngIf="!user"></i>
        <app-picture
            *ngIf="user"
            [picture]="user.picture"
            [size]="'40'"
            format="circle"
            fontSize="14px"
            [default]="user.initials"
        ></app-picture>
    </div>
</div>
